// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ChevronDoubleDownIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronDoubleDown/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m19 13-7 7-7-7m14-8-7 7-7-7"
}));
export default ChevronDoubleDownIcon;